import React from 'react'
import PropTypes from 'prop-types'

import { TableOLD } from '@lmc/ui-kit'
import { getTableColumns, getTableRows } from '../utils'

export default function MedStockLogsTable(props) {
  const { logs, medication, role, router, testId } = props
  const { quantityType, stockQuantityType } = medication
  const showExpectedStock = quantityType === stockQuantityType
  const columns = getTableColumns({ showExpectedStock, stockQuantityType })
  const rows = getTableRows({ logs, role, router, showExpectedStock })

  return (
    <div
      style={{ marginTop: '16px' }}
      data-testid={
        testId ? `${testId}-med-stock-logs-table` : 'med-stock-logs-table'
      }
    >
      <TableOLD columns={columns} rows={rows} />
    </div>
  )
}

MedStockLogsTable.propTypes = {
  logs: PropTypes.array.isRequired,
  medication: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  router: PropTypes.object.isRequired,
  testId: PropTypes.string
}
